import { channel } from "./channel.ts";

export { channel } from "./channel.ts";
export { Realtime } from "./types.ts";

export const realtime = {
  channel,
} as const;
